<template>
    <div class="tagsCon">
        <div class="top-left-font">
            <div
                v-for="(item,index) in tabLists"
                :key="index"
                :class="{bg:leftSelectArray.includes(item.fname)&& index != 0,titleTag:index != 0}"
                style="align-items:center;cursor: pointer;"
            >
                <div @click="toWhichPage(item)" 
                    :class="{fz:index==0}"
                >{{item.fname}}</div>
                <div @click="closeCurrentView(item,index)" v-if="leftSelectArray.includes(item.fname) && index != 0">
                    <i  
                        class="iconfont iconshanchu closeicon" 
                        style="font-size:12px;"  
                    ></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['tabLists','leftSelectArray'],
    data(){
        return{
            isactive:{},
            isSelect:[]
        }
    },
    methods:{
         /**标签跳转页面 */
        toWhichPage(data) {
            this.$emit('toWhichPage',data)
        },
        /**菜单栏的显示状态 */
        changeAsideShow() {
            this.asideShow = !this.asideShow;
            if (this.asideShow === true) {
                this.iconfont = "iconfont icon-close";
            } else if (this.asideShow === false) {
                this.iconfont = "iconfont icon-open";
            }
        },
        /**关闭当前页面 */
        closeCurrentView(i,index) {
            if(index == 0){
                return
            }
            this.$emit('closeCurrentPage',i)
        },
    }
}
</script>

<style lang="scss" scoped>
    // ******History****
    // 分组大类样式
    .fz{
        font-size: 20px;
        font-weight: bold;
    }
    .tagsCon{
        width:80%;
        display: flex;
        flex-direction: row;
        align-items: center;
        
    }
    .fontpic {
        font-size: 15px;
        margin-right: 2px;
    }
    .titleTag {
        display: flex;
        padding:2px 6px;
        div {
            border: 1px solid transparent;
        }
    }
    .titleTag:hover{
        color:#F97D2B;
    }

    .top-left-font {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 15px;
        width: 500px;
        white-space: nowrap;
    }

    .closeicon:hover {
        //关闭按钮
        color:#F97D2B!important;
    }

    .bg {
        display: flex;
        justify-content: center;
        background: #F3F6FF;
        div {
            // color:#145EFF
            color: #F97D2B;
        }
    }
    // ******History****
</style>


// WEBPACK FOOTER //
// src/components/History.vue